export default __webpack_public_path__ + "static/media/1988-2.d6ab93bb.png";